// ExtractionProgress.jsx — progress panel for the two extraction stages.

import { T } from '../../theme';
import { Meter } from '../fmxkit';

export default function ExtractionProgress({ title, label, current, total }) {
  const pct = total ? Math.round((current / total) * 100) : null;
  return (
    <div style={{ background: T.white, border: `1px solid ${T.borderSubtle}`, borderRadius: T.radiusCard, padding: '36px 24px', textAlign: 'center' }}>
      <style>{'@keyframes fbspin { to { transform: rotate(360deg); } }'}</style>
      <div style={{ width: 34, height: 34, margin: '0 auto', border: `4px solid ${T.blue100}`, borderTopColor: T.brand, borderRadius: '50%', animation: 'fbspin 0.8s linear infinite' }} />
      <div style={{ font: `700 15px/21px ${T.fontSans}`, color: T.ink, marginTop: 14 }}>{title}</div>
      <div style={{ font: `400 13px/19px ${T.fontSans}`, color: T.inkMuted, marginTop: 4 }}>{label}</div>
      {pct !== null && (
        <div style={{ maxWidth: 320, margin: '14px auto 0' }}>
          <Meter pct={pct} />
          <div style={{ font: `500 11px/16px ${T.fontData}`, color: T.inkSoft, marginTop: 5 }}>{current} of {total}</div>
        </div>
      )}
    </div>
  );
}
